export interface SimplyMemoizedFunction {
  clearCache: () => void;
}

export function simpleMemoize<T extends (...args: any) => any>(
  f: T,
): T & SimplyMemoizedFunction {
  let cache: Record<string, any> = {};

  function memoized(...args: Parameters<T>) {
    const index = JSON.stringify(args);
    if (cache[index]) {
      return cache[index];
    } else {
      const result: any = f(...args);
      cache[index] = result;
      return result;
    }
  }

  memoized.clearCache = () => (cache = {});

  // @ts-ignore
  return memoized;
}
